import {
  AUTHENTICATED_EXTERNAL_LINK_ROUTE_IDS,
  AuthenticatedExternalLinkRoute,
  resolveMarketingSolutionsBaseUrl,
  resolvePortalOperationsBaseUrl
} from './authenticated-external-link-options';
import {
  appendTokenToSourceHref,
  useApiResponseUrl
} from './resolvers/authenticated-external-link-url.resolvers';

/**
 * Apex hostname used for matching (stg/dev subdomains match via endsWith).
 * Derived from the current environment portal domain.
 */
function matchDomainFromBaseUrl(baseUrl: string): string {
  return new URL(baseUrl).hostname.replace(/^(dev|stg)\./, '');
}

export function createAuthenticatedExternalLinkRoutes(): AuthenticatedExternalLinkRoute[] {
  return [
    {
      id: AUTHENTICATED_EXTERNAL_LINK_ROUTE_IDS.marketingSolutions,
      domains: [matchDomainFromBaseUrl(resolveMarketingSolutionsBaseUrl())],
      urlEndpoint: '/url/MarketingSolutions',
      resolveUrl: appendTokenToSourceHref
    },
    {
      id: AUTHENTICATED_EXTERNAL_LINK_ROUTE_IDS.portalOperations,
      domains: [matchDomainFromBaseUrl(resolvePortalOperationsBaseUrl())],
      urlEndpoint: '/url/PortalOperacoes',
      resolveUrl: useApiResponseUrl
    }
  ];
}
